import { ChangeDetectionStrategy, Component, Input, TemplateRef, output, viewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'custom-sales-rep-customer-switch-confirmation-modal',
  templateUrl: './sales-rep-switch-confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class SalesRepCustomerSwitchConfirmationModalComponent {
  readonly modal = viewChild<TemplateRef<unknown>>('modal');

  @Input() customerID: string;
  @Input() customerName: string;
  readonly confirmed = output<string>();
  readonly cancelled = output<void>();

  modal$: NgbModalRef;

  constructor(private ngbModal: NgbModal) {}

  show() {
    this.modal$ = this.ngbModal.open(this.modal());

    // Listen for modal dismissal (including clicking outside or ESC key)
    this.modal$.result.catch(() => {
      // TODO: The 'emit' function requires a mandatory void argument
      this.cancelled.emit();
    });
  }

  hide() {
    if (this.modal$) {
      this.modal$.dismiss();
    }
    // TODO: The 'emit' function requires a mandatory void argument
    this.cancelled.emit();
  }

  confirmSwitch() {
    this.confirmed.emit(this.customerID);
    if (this.modal$) {
      this.modal$.close();
    }
  }
}
